































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import { getLangType } from '@/api/common'
import { getAndroidLangInfo, getIosLangInfo, addEditIosLang, addEditAndroidLang } from '@/api/files/files-app/filesApp'
import { checkNoneString } from '@/utils/tool'

interface ITab {
  langCode: string
  langName: string
  appName: string
  desc: string
  updateDesc: string
  editorDesc: string
  supportLang?: string
}

@Component({
  name: 'MultiLanguage'
})
export default class extends mixins(DisplayMixin) {
  showSelect = true
  private lang = ''
  private type: 'save' | 'commit' = 'save'
  private id = 0
  private p = ''
  private draftId: number = 0
  private options: any[] = []
  private contentList: Array<ITab> = []
  private langCodeList: string[] = []
  private tabIndex = 0
  // life
  created() {
    this.p = this.$route.query.platform as string
    this.getLanguageType()
    this.id = Number(this.$route.query.id)
    if (this.p === 'ios') {
      this.getIosLangInfo()
    } else {
      this.getAndroidLangInfo()
    }
  }
  // methods
  async getIosLangInfo() {
    let res: any = await getIosLangInfo({
      id: this.$route.query.id
    })
    if (res.data.dataList.length === 0) {
      this['$message'].error('没有应用信息,请先添加相关应用信息')
      return
    }
    let list: ITab[] = res.data.dataList
    list.forEach((item, index) => {
      this.langCodeList.push(item.langCode)
    })
    this.contentList = list
  }
  async getAndroidLangInfo() {
    let res: any = await getAndroidLangInfo({
      id: this.$route.query.id
    })
    if (res.data.length === 0) {
      this['$message'].error('没有应用信息,请先添加相关应用信息')
      return
    }
    let list: ITab[] = res.data
    list.forEach((item, index) => {
      this.langCodeList.push(item.langCode)
    })
    this.contentList = list
  }
  async getLanguageType() {
    let res = await getLangType({
      platform: this.p
    })
    this.options = res.data
  }
  async addEditIosLang() {
    let res: any = await addEditIosLang({
      id: this.id,
      type: this.type,
      draftId: this.draftId,
      descList: this.contentList
    })
    if (res.status.code === 0) {
      if (this.type === 'save') {
        this['$message']('已保存至草稿箱!')
      } else {
        this['$message'].success('提交成功!')
      }
    } else {
      this['$message'].error('提交失败，请稍后重试或联系相关人员!')
    }
  }
  async addEditAndroidLang() {
    let res: any = await addEditAndroidLang({
      id: this.id,
      type: this.type,
      draftId: this.draftId,
      descList: this.contentList
    })
    if (res.status.code === 0) {
      if (this.type === 'save') {
        this['$message']('已保存至草稿箱!')
      } else {
        this['$message'].success('提交成功!')
      }
    } else {
      this['$message'].error('提交失败，请稍后重试或联系相关人员!')
    }
  }
  toggleLang(i: number) {
    this.tabIndex = i
  }
  deleteLang(i: number) {
    let lang = this.contentList[i]['langCode']
    this.contentList.splice(i, 1)
    this.langCodeList.splice(this.langCodeList.indexOf(lang), 1)
    this.tabIndex = 0
  }
  handleDisplay() {
    this.showSelect = !this.showSelect
  }
  handleSelect(v: string) {
    this.showSelect = false
    if (this.langCodeList.includes(v)) {
      this['$message'].error('该语言已存在!')
    } else {
      let list = this.options.filter(item => item.code === v)
      this.contentList.push({
        langCode: v,
        langName: list[0].name,
        appName: '',
        desc: '',
        updateDesc: '',
        editorDesc: '',
        supportLang: ''
      })
    }
    this.langCodeList.push(v)
    this.lang = ''
    this.tabIndex = this.tabIndex + 1
  }
  setDefaultLang(i: number) {
    if (i === 0) {
      this['$message'].warning('该语言已为默认语言!')
    } else {
      this.contentList.splice(0, 1, ...this.contentList.splice(i, 1, this.contentList[0]))
    }
  }
  handeSubmit(type: 'save' | 'commit') {
    this.type = type
    // 非空验证
    let isEmpty = this.contentList.length === 0
    let isNone = this.contentList.some(item => checkNoneString(item, ['langCode', 'langName', 'editorDesc', 'supportLang']))
    if (isNone || isEmpty) {
      this['$message'].error('数据缺失,请填写完整数据!')
    } else {
      if (this.p === 'ios') {
        this.addEditIosLang()
      } else {
        this.addEditAndroidLang()
      }
    }
  }
}
